import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7163495c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagenavigation" }
const _hoisted_2 = { class: "pagenavigation_controls theme theme-light--9" }
const _hoisted_3 = ["disabled", "title"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "newicon-62-1 pagenavigation_icon pagenavigation_icon--backwards" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "pagenavigation_counter p-y-2 p-x-5" }
const _hoisted_7 = ["disabled", "title"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "newicon-62-1 pagenavigation_icon pagenavigation_icon--forwards" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]




export default /*#__PURE__*/_defineComponent({
  props: {
    currentPage: null,
    hasNextPage: { type: Boolean }
  },
  emits: ["nextPage", "prevPage"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "button button--secondary pagenavigation_button",
        disabled: __props.currentPage === 1,
        title: _ctx.$t('prevPage'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('prevPage')))
      }, _hoisted_5, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_6, _toDisplayString(__props.currentPage), 1),
      _createElementVNode("button", {
        class: "button button--secondary pagenavigation_button",
        disabled: !__props.hasNextPage,
        title: _ctx.$t('nextPage'),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('nextPage')))
      }, _hoisted_9, 8, _hoisted_7)
    ])
  ]))
}
}

})